var _templateObject, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgEmptyStaked = function SvgEmptyStaked(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E2D2",
    stroke: "#000",
    strokeWidth: 1.8,
    d: "M3.071 40.782A1.984 1.984 0 0 1 1.09 38.8V13.287c0-1.742.728-3.429 2.05-4.751L8.477 3.2c1.322-1.322 3.01-2.051 4.75-2.051h20.961a6.54 6.54 0 0 1 6.535 6.535V38.8a1.984 1.984 0 0 1-1.982 1.982z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.837 5.499H16.74a2.537 2.537 0 0 0-2.537 2.537v22.296a2.537 2.537 0 0 0 2.538 2.537h17.096a2.537 2.537 0 0 0 2.537-2.537V8.036A2.537 2.537 0 0 0 33.837 5.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M33.835 33.754H16.739a3.427 3.427 0 0 1-3.423-3.422V8.036a3.427 3.427 0 0 1 3.423-3.422h17.096a3.427 3.427 0 0 1 3.423 3.422v22.296a3.427 3.427 0 0 1-3.423 3.422M16.739 6.384c-.911 0-1.653.741-1.653 1.652v22.296c0 .91.742 1.652 1.653 1.652h17.096c.911 0 1.653-.741 1.653-1.652V8.036c0-.91-.742-1.652-1.653-1.652z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M32.327 5.499H16.6a2.396 2.396 0 0 0-2.397 2.396v22.619a2.356 2.356 0 0 0 2.356 2.356h15.808a2.356 2.356 0 0 0 2.355-2.356V7.895A2.396 2.396 0 0 0 32.326 5.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M32.28 33.754H16.642a3.33 3.33 0 0 1-3.326-3.326V7.94a3.33 3.33 0 0 1 3.326-3.326H32.28a3.33 3.33 0 0 1 3.326 3.326v22.488a3.33 3.33 0 0 1-3.326 3.326M16.642 6.384c-.858 0-1.556.698-1.556 1.556v22.488c0 .858.699 1.556 1.556 1.556H32.28c.858 0 1.556-.698 1.556-1.556V7.94c0-.858-.698-1.556-1.556-1.556z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M28.577 13.71H25.84v2.737h2.737zM23.104 13.71h-2.737v2.737h2.737zM25.841 19.184h-5.474v2.737h8.211v-2.737zM31.315 21.921h-2.737v2.737h2.737zM20.366 21.921h-2.737v2.737h2.737z"
  }))));
};
export default SvgEmptyStaked;